const lowRiskProcess = (processStats) => {
  return processStats?.departments?.reduce(
    (value, department) => value + department.risks?.low,
    0,
  )
}

export default lowRiskProcess
